const body = document.querySelector('body');
const loading = document.createElement('div');
loading.innerHTML = '<div class="spinner"><img src="' + process.env.VUE_APP_CDN_URL + 'assets/spinner.gif"/></div>';
loading.setAttribute('id', 'loading');
body.appendChild(loading);

export default {
  start () {
    body.style.overflowY = 'hidden';
    loading.style.display = 'block';
  },
  done () {
    body.style.overflowY = '';
    loading.style.display = 'none';
  },
};
